"use client";

import { useEffect } from "react";
import Link from "@/components/locale-link";
import { Button } from "@/components/ui/button";

export default function ErrorPage({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    console.error(error);
  }, [error]);

  return (
    <div className="bg-background">
      <main className="site-container animate-fade-in py-10 md:py-12">
        <div className="flex flex-col items-center space-y-6 py-20 text-center">
          <h1 className="font-semibold text-3xl text-foreground tracking-tight md:text-4xl">
            Something went wrong
          </h1>
          <p className="max-w-md text-base text-muted-foreground leading-relaxed md:text-lg">
            An unexpected error occurred. You can try again or head back to the
            home page.
          </p>
          {error.message && (
            <div className="w-full max-w-md rounded-lg border border-border bg-muted/50 px-4 py-3">
              <p className="break-words text-muted-foreground text-sm">
                {error.message}
              </p>
            </div>
          )}
          <div className="flex flex-wrap items-center justify-center gap-3 pt-4">
            <Button onClick={reset}>Try Again</Button>
            <Button asChild variant="outline">
              <Link href="/">Go Home</Link>
            </Button>
          </div>
        </div>
      </main>
    </div>
  );
}
